/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { useCustomer } from "~/context";
import {
  SummaryCard,
  TopSummaryWidget,
  DistinctUpdateFailures,
} from "./components";
import { useDashboardResources } from "./hooks";

const Row = styled(FlexContainer)`
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${theme.spacing.spacing02};
  align-items: stretch;

  & + & {
    margin-top: ${theme.spacing.spacing02};
  }
`;

export function Dashboard() {
  const { customer } = useCustomer();
  const {
    refetch,
    resourcesOsList,
    loading: resourcesLoading,
    resourcesStatus,
    count: resourcesCount,
    lastUpdateStatus,
  } = useDashboardResources();

  useEffect(() => {
    refetch();
  }, [refetch, customer]);

  return (
    <>
      <Row>
        <TopSummaryWidget
          resourcesStatus={resourcesStatus}
          resourcesTotal={resourcesCount}
          resourcesLoading={resourcesLoading}
        />
      </Row>
      <Row
        css={{
          "& > div": {
            flex: "1 0 460px",
            height: "320px",
          },
        }}
      >
        <SummaryCard
          title="Last Update Status"
          items={lastUpdateStatus.data}
          loading={lastUpdateStatus.loading}
        />
        <SummaryCard
          title="Resources by Operating System"
          items={resourcesOsList}
          loading={resourcesLoading}
        />
        <DistinctUpdateFailures />
      </Row>
    </>
  );
}
